<template>
	<v-container class="px-0">
		<v-row>
			<v-col>
				<v-card
					:loading="loading"
					class="mx-auto"
					max-width="100%"
				>
					<template slot="progress">
						<v-progress-linear
							color="#F15A24"
							height="2"
							indeterminate
						></v-progress-linear>
					</template>

					<v-img
						v-if="user.capa"
						style="
							-webkit-mask-image: linear-gradient(
								180deg,
								#000 70%,
								transparent
							);
						"
						height="300px"
						cover
						:src="`https://api.mylegis.com.br/assets/${user.capa}`"
						class="d-flex align-end"
					/>

					<v-card-title class="pb-0">
						<v-img
							max-width="100px"
							height="100px"
							class="rounded-circle"
							:src="
								user.avatar !== null
									? `https://api.mylegis.com.br/assets/${user.avatar}`
									: require(`../assets/icon-person.svg`)
							"
						/>
						<h3 class="ml-3 ">{{ user.first_name }}

					<v-btn v-if="user.id !== $store.state.user.id" color="#F15A24" class="w-100" dark small @click="adicionar(user)" :disabled="user.adicionado"><v-icon>mdi-plus</v-icon>{{user.adicionado ? `Adicionado` : `Enviar convite de amizade` }}</v-btn>
						</h3>
					</v-card-title>

					<v-card-text>
						<ul class="w-100 pl-0 d-flex justify-center">
							<li>
								<v-btn
									text
									@click="tab = `annotations`"
								>
									<v-icon class="mr-1">mdi-pencil</v-icon>
									Anotações ({{ anotacoes.length }})
								</v-btn>
							</li>
							<li>
								<v-btn
									text
									@click="tab = `vademecuns`"
								>
									<v-icon class="mr-1">mdi-bookshelf</v-icon>
									Vade-mécuns ({{ vademecums.length }})
								</v-btn>
							</li>
							<li>
								<v-btn
									text
									@click="tab = `friends`"
								>
									<v-icon class="mr-1">mdi-account-group</v-icon>
									Amigos ({{ user.amigos.length }})
								</v-btn>
							</li>
							<!-- <li>
                                <v-btn text>
                                    <v-icon>mdi-account-circle</v-icon>
                                    Sobre
                                </v-btn>
                            </li> -->
						</ul>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col
				cols="12"
				lg="3"
				class="h-100"
			>
			
				<div
					class="gt-tag mx-auto w-100"
					:style="{ backgroundColor: `#e1e1e1` }"
				>
					<h4>Sobre</h4>
				</div>
				<p class="pa-2 mb-0">
					<v-icon class="mr-2">mdi-briefcase-outline</v-icon
					>{{ user.tags ? user.tags[0] : '' }}
				</p>
				<p class="pa-2">
					<v-icon class="mr-2">mdi-information</v-icon>{{ user.sobre }}
				</p>
			</v-col>
			<v-col
				v-if="loadingFeed"
				cols="12"
				lg="9"
				class="text-center"
			>
				<v-progress-circular
					class="mx-auto"
					color="#F15A24"
					indeterminate
				></v-progress-circular>
			</v-col>
			<v-col
				v-show="tab === `friends`"
				cols="12"
				lg="9"
			>
				<v-list>
					<v-list-item
						v-for="amigo in user.amigos"
						:key="amigo.i"
						class="mb-2 elevation-1 rounded"
					>
						<v-list-item-avatar v-if="amigo.id_amigo">
							<v-img
								max-width="40px"
								height="40px"
								class="mr-3 rounded-circle"
								cover
								:src="
									amigo.id_amigo.avatar !== null
										? `https://api.mylegis.com.br/assets/${amigo.id_amigo.avatar}`
										: require(`../assets/icon-person.svg`)
								"
							/>
						</v-list-item-avatar>
						<v-list-item-content v-if="amigo.id_amigo">
							<v-list-item-title>
								<router-link
									:to="`/painel/u/${amigo.id_amigo.id}/${sanitizeTitle(
										amigo.id_amigo.first_name
									)}`"
								>
									{{ amigo.id_amigo.first_name }}
								</router-link>
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action 
							v-if="amigo.id_amigo && amigo.id_amigo.id !== $store.state.user.id"
						>
							<v-btn
								@click="solicitarAmizade(amigo.id_amigo)"
								:disabled="amigo.id_amigo.adicionado"
								style="border-color: 1px solid #f15a24; color: #f15a24"
								outlined
								class="ml-n15"
							>
								<v-icon>mdi-account-plus</v-icon
								>{{ amigo.id_amigo.adicionado ? `Solicitado` : `Solicitar` }}
								Amizade
							</v-btn>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-col>
			<v-col
				v-show="tab === `annotations`"
				cols="12"
				lg="9"
			>
				<annotation
					:annotation="annotation"
					v-for="(annotation, i) in anotacoes"
					:key="i"
				></annotation>
			</v-col>
			<v-col
				cols="12"
				lg="9"
			>
				<p
					v-show="tab === `vademecuns`"
					class="w-100 pa-2"
				>
					<!-- <h3>Vade-mécuns públicos</h3> -->
					<v-list>
						<v-list-item
							v-for="v in vademecums"
							:key="v.id"
						>
							<v-btn
								class="text-left"
								text
								@click="
									vademecumSeleceted = v;
									showDialogVerLeis = true;
								"
							>
								<v-avatar
									class="mr-1"
									size="25"
									:color="v.cor ? v.cor : `#f57029`"
								></v-avatar>
								{{ v.titulo ? v.titulo : '' }}
								({{ v.leis.length }} leis)
							</v-btn>
						</v-list-item>
					</v-list>
				</p>
			</v-col>
		</v-row>
		<v-dialog
			m
			width="850px"
			v-model="showDialogVerLeis"
		>
			<v-card>
				<v-card-title class="d-flex justify-space-between flex-row">
					<div class="mb-0 d-flex flex-column align-start">
						<p class="mb-0">
							<v-menu :close-on-content-click="false">
								<template v-slot:activator="{ on: menu, attrs }">
									<v-tooltip
										offset-y
										bottom
									>
										<template v-slot:activator="{ on: tooltip }">
											<v-btn
												icon
												v-bind="attrs"
												v-on="{ ...tooltip, ...menu }"
												:disabled="!vademecumSeleceted.edit"
												dark
											>
												<v-avatar
													size="28"
													:color="
														vademecumSeleceted.cor
															? vademecumSeleceted.cor
															: `#f57029`
													"
													class="mr-1"
												>
												</v-avatar>
											</v-btn>
										</template>
									</v-tooltip>
								</template>
							</v-menu>
							<span>Legislações em</span>
							<input
								ref="edit"
								class="ml-2"
								:style="{
									color: vademecumSeleceted.cor
										? vademecumSeleceted.cor
										: `#f57029`,
								}"
								:size="
									vademecumSeleceted.titulo
										? vademecumSeleceted.titulo.length - 3
										: ``
								"
								color="#f57029"
								v-model="vademecumSeleceted.titulo"
								:disabled="!vademecumSeleceted.edit"
								:class="vademecumSeleceted.edit ? `borda-laranja` : ``"
							/>
							<!-- 
                            <v-btn @click="showDialogAddLeiToVade = true" outlined><v-icon
                                    color="#f57029">mdi-plus</v-icon>
                                Adicionar legislação
                            </v-btn> -->
						</p>
						<p class="mb-0">
							<span>
								<!-- <v-btn v-if="!vademecumSeleceted.edit" @click="editVD" text small>
                                    <v-icon small color="#f57029">mdi-pencil</v-icon> Editar
                                </v-btn> -->
								<v-btn
									v-if="vademecumSeleceted.edit"
									@click="editarVadeMecum()"
									:loading="savingVadeMecum"
									small
									text
								>
									<v-icon
										small
										color="#f57029"
										>mdi-check</v-icon
									>
									Salvar
								</v-btn>
								<v-btn
									v-if="vademecumSeleceted.edit"
									@click="vademecumSeleceted.edit = false"
									text
									small
								>
									<v-icon small>mdi-close</v-icon> Cancelar
								</v-btn>
							</span>
						</p>
					</div>
					<v-btn
						@click="
							showDialogVerLeis = false;
							clearVadeMecumBusca();
						"
						icon
					>
						X
					</v-btn>
				</v-card-title>
				<v-card-text>
					<!-- <v-text-field v-if="vademecumSeleceted.leis.length > 0" hide-details
                         outlined
                        :append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" color="#f57029"
                        label="Pesquise por conteúdos nas legislações deste vade-mécum" class="my-4">

                    </v-text-field> -->
					<!-- v-on:keyup.enter="searchConteudoVadeMecum" clearable v-model="buscaVadeMecum" -->
					<!-- @click:clear="clearVadeMecumBusca" @click:append="searchConteudoVadeMecum" -->
					<v-expansion-panels>
						<v-expansion-panel
							v-if="vademecumSeleceted.leis.length === 0"
							class="d-flex align-center justify-center"
						>
							<p class="mb-0 py-5">
								Este vade-mécum ainda não possui legislações. Adicione
								legislações clicando no botão abaixo.
							</p>
						</v-expansion-panel>
						<v-expansion-panel
							v-for="lei in vademecumSeleceted.leis"
							:key="lei.id"
							:disabled="
								lei.retornoBusca ? lei.retornoBusca.length === 0 : false
							"
						>
							<v-expansion-panel-header class="d-flex justify-space-between">
								<p
									class="mb-0 d-flex flex-column align-start"
									style="width: 100%"
								>
									<span>
										{{ lei.leis_id_lei.numero_lei }}
										<!-- <v-btn x-small text color="#f15a24" :to="'/painel/lei/' +
                                            lei.leis_id_lei.id_lei +
                                            '/' + sanitizeTitle(lei.leis_id_lei.numero_lei)
                                            ">
                                            <v-icon color="#F15A24" x-small text>mdi-file-document</v-icon>
                                            Ver Legislação
                                        </v-btn> -->
									</span>
									<br />
									<small class="my-2">{{ lei.leis_id_lei.nome_lei }} </small>
									<v-divider
										class="my-3"
										style="width: 100%"
									></v-divider>
								</p>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<p
									v-for="c in lei.retornoBusca"
									:key="`vd${c.id_reg}`"
								>
									<span v-html="highlight(c.conteudo, buscaVadeMecum)"></span>
									<v-btn
										text
										small
										class="mx-1 opacity-75"
										:to="`/painel/lei/${lei.leis_id_lei.id_lei}/${sanitizeTitle(
											lei.leis_id_lei.numero_lei
										)}?id=${c.id_reg}`"
									>
										<v-icon color="#f57029">mdi-arrow-right-top</v-icon> Ir até
										o conteudo
									</v-btn>
								</p>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-card-text>
				<v-card-actions class="d-flex justify-center">
					<p
						v-if="
							loggedUser.plano === `plano-free` || loggedUser.plano === null
						"
					>
						Ative já seu
						<router-link to="/painel/perfil">Plano Carreira</router-link> para
						importar vade-mécuns de outros usuários
					</p>
					<v-btn
						@click="importarVadeMecum"
						:disabled="
							loggedUser.plano === `plano-free` || loggedUser.plano === null
						"
						:loading="loadingNewVade"
						large
						color="#F15A24"
						dark
						>Importar Vade-mécum</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<style scoped>
	li {
		list-style-type: none;
		float: left;
		padding: 5px;
	}
	a {
		color: black;
		text-decoration: none;
	}
	a:hover {
		color: #f15a24;
		text-decoration: underline;
	}
</style>
<script>
	import Annotation from '../components/Annotation.vue';
	export default {
		name: 'PerfilUsuario',
		components: { Annotation },
		data() {
			return {
				buscaVadeMecum: '',
				loadingSearch: false,
				showDialogVerLeis: false,
				tab: 'annotations',
				loading: false,
				loadingFeed: false,
				user: { amigos: [] },
				vademecums: [],
				anotacoes: [],
				vademecumSeleceted: { leis: [] },
				editVD: false,
				loadingNewVade: false,
			};
		},
		computed: {
			loggedUser() {
				return this.$store.state.user != undefined
					? this.$store.state.user
					: { first_name: 'Meu Perfil', plano: null };
			},
		},
		mounted() {
			let idUsuario = this.$route.params.idUsuario;
			// window.console.log(idUsuario)
			if (idUsuario) {
				this.getUsuario(idUsuario);
			}
		},
		watch: {
			'$route.params.idUsuario': {
				handler: function (idUsuario) {
					if (idUsuario) {
						this.getUsuario(idUsuario);
					}
				},
				deep: true,
				immediate: true,
			},
		},
		methods: {
			adicionar(user) {
				let share = {
					id_adicionado: user.id,
					id_usuario: this.$store.state.user.id,
				};

				this.$http.post("items/add_amigo", share).then((response) => {
					if (response.data.data.id != undefined) {
					// this.menuShow = false;
					this.snackbar = true;
					user.adicionado=true
					// this.cleanFields();
					}
				});
			},
			searchConteudoVadeMecum() {},
			solicitarAmizade(user) {
				let share = {
					id_adicionado: user.id,
					id_usuario: this.$store.state.user.id,
				};
				this.$http.post('items/add_amigo', share).then((response) => {
					if (response.data.data.id != undefined) {
						user.adicionado = true;
						alert('Convite enviado com sucesso!');
						this.$forceUpdate();
					}
				});
			},
			async importarVadeMecum() {
				window.console.log(this.vademecumSeleceted);
				this.loadingNewVade = true;
				const { data } = await this.$http.post('/items/vademecums', {
					titulo: this.vademecumSeleceted.titulo,
					cor: this.vademecumSeleceted.cor,
					status: 'published',
				});

				const mapLeis = this.vademecumSeleceted.leis.map((e) => ({
					leis_id_lei: { id_lei: e.leis_id_lei.id_lei },
					vademecums_id: data.data.id,
				}));

				for (const law of mapLeis) {
					const lawId = law.leis_id_lei.id_lei;
					const vademecumId = law.vademecums_id;
					const responseAnnotations = await this.$http.get(
						`/items/anotacoes?filter[id_lei][_eq]=${lawId}&filter[user_created][_eq]=${this.vademecumSeleceted.user_created}&filter[status][_in]=published,private&fields=id_reg,texto,status`
					);
					if (responseAnnotations.data.data.length > 0) {
						for (const annotation of responseAnnotations.data.data) {
							await this.$http.post(`/items/anotacoes`, {
								status: annotation.status,
								texto: annotation.texto,
								id_lei: lawId,
								id_reg: annotation.id_reg,
								id_vademecum: vademecumId,
							});
						}
					}
				}

				const dt1 = this.$http.patch('/items/vademecums/' + data.data.id, {
					leis: { create: mapLeis },
				});
				window.console.log(dt1);
				this.loadingNewVade = false;
				this.showDialogVerLeis = false;
				// this.$router.go("/painel/legislacoes")
			},
			async loadFeed() {
				this.loadingFeed = true;
				const query = `query PublicAnnotations {
	         anotacoes(filter: {
	               _and: [
	                   { status: { _eq: "published" }},
	                   { user_created: { id: { _eq: "${this.user.id}"}}}
	               ]
	           }) {
	           id
	           texto
	           date_created
	           date_updated
	           status
	           likes { id, first_name }
	           user_created {
	             first_name
	             last_name
	             id
	             avatar {
	               id
	             }
	           }
	           id_lei {
	             id_lei
	             numero_lei
	           }
	           id_reg {
	             id_reg
	             conteudo
	           }
	         }
	       }
	     `;

				const {
					data: { data },
				} = await this.$http.post('/graphql', {
					query,
				});
				this.anotacoes = this.anotacoes.concat(data.anotacoes);

				this.anotacoes.sort((a, b) => {
					return (
						new Date(
							b.date_updated === null ? b.date_created : b.date_updated
						) -
						new Date(a.date_updated === null ? a.date_created : a.date_updated)
					);
				});

				this.loadingFeed = false;
			},
			async getUsuario(id) {
				this.loading = true;
				const { data } = await this.$http(
					'/users/' + id + '?fields=*,amigos.id_amigo.*'
				);
				// window.console.log(data)
				this.user = data.data;
				this.getVademecuns();
				this.loadFeed();
				this.loading = false;
			},
			async getVademecuns() {
				const { data } = await this.$http(
					`/items/vademecums?fields=*,leis.id,leis.leis_id_lei.*&filter[user_created][_eq]=${this.user.id}&filter[status][_eq]=public`
				);
				this.vademecums = data.data;
			},
			sanitizeTitle(title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');

				return slug;
			},
		},
	};
</script>
